import styled from 'styled-components'

export const WindowTimeStyled = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 400px;
    margin-right: 20px;
`

export const WindowTimeText = styled.div`
    font-size: 16px;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.greyishBrown};
`

export const WindowTimeBar = styled.div`
    position: relative;
    flex: 1;
    height: 4px;
    margin: 0 10px;
    background: ${({ theme }) => theme.blueyGrey22};
`

export const Progress = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: ${({ progress }) => progress}%;
    height: 100%;
    background: ${({ theme }) => theme.pastelRed};
`

